import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import * as categoriesActions from '@app/marketplace/categories/state/category-tree/category-tree-actions';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CategoryTreeResolver implements Resolve<boolean> {
  constructor(private store: Store<any>,
              @Inject(PLATFORM_ID) private platformId) {
  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise((resolve, reject) => {
      this.loadCategoryTree();
      resolve(true);
    });
  }

  loadCategoryTree() {
    if(isPlatformBrowser(this.platformId)) {
      this.store.dispatch(categoriesActions.GetCategoryTree());
    }
  }
}
